import React, { useState, useRef, useEffect } from "react";
import "../styles/DashboardNeedHelpStyles.css";
import CloseButton from "../assets/needhelp/dashNeedHelpClose.svg";
import MailImg from "../assets/needhelp/dashboardmailimg.svg";
import { Tab, Tabs } from "@mui/material";
import CurriculumProgramNeedHelpComponent from "./CurrProgNeedHelpComponent";
import DashboardNeedHelpOverallProgress from "./NeedHelpOverAllProgress";
import DashboardNeedHelpEngagementScore from "./NeedHelpEngagementScore";
import JozunaSkillsPerformanceComponent from "./JozunaSkillsNeedHelpComponent";
import faqIcon from "../assets/needhelp/faqIconBgWhite.png";
import ProgramScheduleNeedHelp from "./ProgramScheduelNeedHelp";
export interface RightModalProps {
  isOpen?: boolean;
  toggleModal?: () => void;
}

const DashboardNeedHelp: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        const tolerance = 10; // Larger tolerance to handle edge cases

        setIsScrolledToTop(scrollTop <= tolerance);
        setIsScrolledToBottom(
          scrollTop + clientHeight >= scrollHeight - tolerance,
        );
      }
    };
    const refCurrent = contentRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    handleScroll();

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isOpen]);

  const handleScrollDown = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const handleScrollUp = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: -1000, behavior: "smooth" });
    }
  };

  const onTabChange = (index: number) => {
    setActiveTab(index);
  };
  return (
    <>
      {isOpen && (
        <div className="dashboardv2-needhelp-overlay" onClick={toggleModal} />
      )}
      <div
        className={`dashboardv2-needhelp-right-modal ${isOpen ? "open" : ""}`}
      >
        {/* Dashboard Need Help Header */}
        <div className="dashboardv2-needhelp-header">
          <div className="dashboardv2-needhelp-headerrow">
            <img src={faqIcon} alt="contact-button" />
            <h4>Need help?</h4>
          </div>
          <div className="dashboardv2-needhelp-header-end">
            <div className="dashboardv2-needhelp-contact-header">
              <img
                src={MailImg}
                className="dashboardv2-needhelp-contact-image"
                alt="contact-button"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              />
              <div
                className="dashboardv2-needhelp-contact-text"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              >
                Get Support
              </div>
            </div>
            <img
              src={CloseButton}
              className="dashboardv2-close"
              onClick={toggleModal}
              alt="close-button"
            />
          </div>
        </div>
        {/* Dashboard Need Help Body Top */}
        <div className="dashboardv2-needhelp-content">
          {/* Need Help Top Content */}
          {/* <div className="dashboardv2-top-header-top-content">
          <div className="dashboardv2-top-header-main-text">
            Welcome to your personalized growth area!
          </div>
          <div className="dashboardv2-top-header-sub-text">
            {" "}
            This dashboard is designed to give you a clear and comprehensive
            view of your learning journey on the Jozuna platform. Below are
            answers to some common questions about what you're seeing.
          </div>
        </div> */}
        </div>
        {/* Need Help Tab bar */}
        <div className="ass-needhelp-tab-container">
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => onTabChange(newValue)}
            sx={{
              "& .MuiTabs-indicator": {
                background: "#054472",
                height: "5px",
                borderRadius: "4px 4px 0px 0px",
                transition: "left 0.3s ease",
              },
              "& .MuiTab-root": {
                marginLeft: "20px",
                fontSize: "18px",
                fontWeight: "400", // Default font weight
                color: "#555", // Default color
                textTransform: "none",
              },
              "& .Mui-selected": {
                fontWeight: "700", // Bold active tab
                color: "#054472", // Active tab color
              },
            }}
          >
            <Tab
              className={`ass-needhelp-tab ${activeTab === 0 ? "selected" : ""}`}
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    Overall Progress{" "}
                  </span>
                </div>
              }
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Completion Tracking{" "}
                  </span>
                </div>
              }
              className={`tab ${activeTab === 1 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Learning Schedule{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 2 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Jozuna Skills Performance{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 3 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Curriculum & Professional Performance{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 4 ? "selected" : ""}`}
            />
          </Tabs>
        </div>
        {/* Divider */}
        <div
          className="curriculum-needhelp-horizontal-divider"
          style={{ marginLeft: "15px", marginRight: "15px" }}
        ></div>

        {/* Overall Progress */}
        {activeTab == 0 && <DashboardNeedHelpOverallProgress isOpen={isOpen} />}
        {/* Engagement Score */}
        {activeTab == 1 && <DashboardNeedHelpEngagementScore isOpen={isOpen} />}

        {/* Jozuna Skills Performance  */}
        {activeTab == 3 && (
          <JozunaSkillsPerformanceComponent
            isOpen={isOpen}
          ></JozunaSkillsPerformanceComponent>
        )}
        {activeTab == 2 && (
          <ProgramScheduleNeedHelp isOpen={isOpen}></ProgramScheduleNeedHelp>
        )}
        {/* Curriculum & Program Performance  */}
        {activeTab == 4 && (
          <CurriculumProgramNeedHelpComponent
            isOpen={isOpen}
          ></CurriculumProgramNeedHelpComponent>
        )}

        {/* Need Help Scroll Button */}
        {/* <div className="dashboard-scroll-buttons">
        <img
          height={"60px"}
          width={"120px"}
          src={isScrolledToBottom ? ScrollUpButton : ScrollDownButton}
          alt={isScrolledToBottom ? "Scroll Up" : "Scroll Down"}
          className="dashboard-scroll-btn"
          onClick={isScrolledToBottom ? handleScrollUp : handleScrollDown}
          style={{ cursor: "pointer" }}
        />
      </div> */}
      </div>
    </>
  );
};

export default DashboardNeedHelp;
